import type { ChangelogEntry, ChangelogFeed } from "@/types/changelog";

// Straight to the Spidra API (not the marketing site) — the changelog now
// lives in the product's own database. Cross-origin from the dashboard, but
// app.spidra.io is already in the backend's CORS allowlist.
const FEED_URL = process.env.NEXT_PUBLIC_CHANGELOG_URL || "https://api.spidra.io/api/changelog";

const PUBLIC_CHANGELOG_URL =
  process.env.NEXT_PUBLIC_CHANGELOG_PAGE || "https://spidra.io/changelog";

let cache: { at: number; entries: ChangelogEntry[] } | null = null;
const TTL = 10 * 60 * 1000; // 10 min per browser session

/**
 * Fetch the changelog feed from the Spidra API. Unauthenticated, cached in
 * memory for the session. Returns [] on any failure so the caller can just
 * hide the widget.
 */
export async function fetchChangelog(): Promise<ChangelogEntry[]> {
  if (cache && Date.now() - cache.at < TTL) return cache.entries;
  try {
    const res = await fetch(`${FEED_URL}?limit=20`, { headers: { Accept: "application/json" } });
    if (!res.ok) return cache?.entries ?? [];
    const data = (await res.json()) as ChangelogFeed;
    const entries = Array.isArray(data.entries) ? data.entries : [];
    cache = { at: Date.now(), entries };
    return entries;
  } catch {
    return cache?.entries ?? [];
  }
}

export const changelogPageUrl = PUBLIC_CHANGELOG_URL;
